<template>
    <div class="image-list">
        <div :key="index" v-for="(image, index) in images" class="image-item">
            <image-item :image="image"/>
        </div>
    </div>
</template>

<script>
import ImageItem from '@/modules/ProjectModule/modules/UnitModule/components/Image/ImageItem';

export default {
    name:       'ImageList',
    components: {ImageItem},
    computed:   {
        images() {
            return this.$store.getters['projects/project/units/unit/images'];
        }
    },
}
</script>
